// 登录（login）业务域接口（供登录界面使用，如微信 code 登录、手机号一键登录等），写法见 README.md
import { http, httpPost } from '@/http'

/**
 * 用户资料（UserVo，getNumberToLogin / getLoginUserInfo 返回的 userInfo 共用，只声明 v2 使用的字段；
 * 身份 identity、已选城市 cityCode / cityName 都在这里）
 */
export interface LoginUserInfo {
  /** 用户 id */
  userId?: number | string
  /** 用户名/昵称 */
  userName?: string
  /** 手机号 */
  userPhone?: string
  /** 头像地址（可能为空，展示时用默认头像兜底） */
  avatar?: string
  /** 用户身份：1-全民经纪人 / 2-普通用户 / 3-其他业务角色 */
  identity?: number
  /** 房产小程序已选城市 code（swagger 声明 integer，城市接口实测返回字符串，消费方统一 String() 归一） */
  cityCode?: number | string
  /** 房产小程序已选城市名称 */
  cityName?: string
  /** 后端还会返回若干字段（aucard / stakeholders 等），未纳入 v2 使用范围 */
  [key: string]: unknown
}

/**
 * 登录/登录用户信息共用返回结构（LoginVo；getNumberToLogin 与 getLoginUserInfo 返回一模一样，
 * 只声明 v2 使用的字段：身份与城市在 userInfo 里，外层 codes 已不再使用）
 */
export interface LoginResult {
  /** 登录令牌 */
  token?: string
  /** 用户资料（未登录/初始态无值，消费方需空值守卫） */
  userInfo?: LoginUserInfo
}

/** 手机号一键登录（code 为微信 getPhoneNumber 授权返回的动态令牌） */
export function phoneNumberLoginApi(code: string) {
  return httpPost<LoginResult>('/hxyj/mini/getNumberToLogin', { code })
}

/**
 * 用 uni.login 的临时 code 换当前微信用户 openId（data 即 openId 字符串）。
 * 后端路径名叫 UnionID 但实际返回 openId（沿用 v1 约定）；获取失败不弹 toast，
 * openId 缺失不影响主流程（请求头 ownId 传空）。
 */
export function getUnionIdApi(code: string) {
  return http<string>({ url: '/hxyj/mini/getUnionID', query: { code }, method: 'GET', hideErrorToast: true })
}
